// prettier-ignore

import styled from 'styled-components'
import * as Dialog from '@radix-ui/react-dialog'

interface ModalStyleProps {
  top: string
  left: string
  height: string
  width: string
  borderradius: string
  backgroundcolor: string
  padding?: string
}

export const DialogRoot = styled(Dialog.Root)``
export const DialogOverlay = styled(Dialog.Overlay)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  inset: 0;
  background-color: #0000004d;
  z-index: 15;
`
export const DialogPortal = styled(Dialog.Portal)``
export const DialogContent = styled(Dialog.Content)<ModalStyleProps>`
  position: fixed;
  z-index: 15;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  background-color: ${(props) => props.backgroundcolor};
  border-radius: ${(props) => props.borderradius};
  overflow: auto;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  transform: translate(-50%, -50%);
  padding: ${(props) => props.padding};
  text-align: center;
  :focus {
    outline: 0;
    box-shadow: none;
  }
`
